module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338628/mv-e19cbfe14ae88b7fbb3c11ed1e53f4e2.png";